import InfoTeaser from './InfoTeaser';
export * from './InfoTeaser';
export default InfoTeaser;
